<div class="send-to-soc-dialog">
  <div class="dialog-header">
    <div class="dialog-title-section">
      <div class="dialog-icon-container">
        <img class="dialog-icon" src="assets/images/menu-icons/unplug-purple.svg" alt="Adapter" />
      </div>
      <h2>{{ dialogTitle }}</h2>
    </div>
    <img
      class="close-button"
      src="assets/images/common/cancel.svg"
      (click)="onCancel()"
      [class.disabled]="isLoading$ | async"
      alt="Close"
    />
  </div>

  @if (errorMessage) {
    <div class="error-banner">
      <span>⚠️</span>
      <span>{{ errorMessage }}</span>
    </div>
  }

  @let isLoading = isLoading$ | async;
  @let adapters = adapters$ | async;

  @if (isLoading) {
    <div class="loading-container">
      <mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
    </div>
  } @else if (adapters && adapters.length > 0) {
    <div class="dialog-content">
      <div class="adapters-list">
        <p class="list-label">Select an adapter to send the finding:</p>
        @for (adapter of adapters; track adapter.id) {
          <div
            class="adapter-item"
            [class.selected]="selectedAdapterId === adapter.id"
            (click)="selectedAdapterId = adapter.id"
          >
            <div class="adapter-info">
              <div class="adapter-name">{{ adapter.name }}</div>
              <div class="adapter-description">{{ adapter.description }}</div>
            </div>
            @if (selectedAdapterId === adapter.id) {
              <div class="selected-indicator">✓</div>
            }
          </div>
        }
      </div>
    </div>

    <div class="dialog-footer">
      <button mat-stroked-button (click)="onCancel()" [disabled]="isLoading" class="cancel-button">Cancel</button>
      <button mat-flat-button color="primary" [disabled]="isSendDisabled" (click)="onSend()" class="send-button">
        Send
      </button>
    </div>
  } @else {
    <div class="no-adapters">
      <p>No enabled Splunk adapters available.</p>
      <p>Please configure a Splunk adapter first.</p>
    </div>
    <div class="dialog-footer">
      <button mat-stroked-button (click)="onCancel()" class="cancel-button">Close</button>
    </div>
  }
</div>
